import {
  SetMatchTrackTable,
  TrackTableCell,
  TrackTableHeader,
  SetMatchTrackName,
  OrgNameCell,
} from "./styles";
import { RoundTimeRows } from "../RoundTimeRows";
import { WorldTourTrack } from "model/Match/Set/WorldTour/Track/WorldTourTrack";
import { selectRosterDisplayName } from "selectors/Roster";
import { FlexRow } from "styles/layout";
import { MatchTeams } from "model/Match/MatchTeams";
import {
  getRosterIdOrPlaceholder,
  isPlaceholderRoster,
} from "model/Roster/Roster";
import { MatchmakingTrack } from "model/Match/Set/Matchmaking/Track/MatchmakingTrack";
import { MatchTrack } from "model/Match/Track/MatchTrack";
import { selectTrackNameFromTournamentId } from "selectors/Tournament";
import { useAppSelector } from "app/hooks";

interface Props {
  track: MatchmakingTrack | WorldTourTrack;
  trackNum: number;
  teams: MatchTeams;
  tournamentId: string;
}

export const WorldTourTrackTimes = ({
  track,
  trackNum,
  teams,
  tournamentId,
}: Props) => {
  const rosterOne = teams.rosters[0];
  const rosterOneId = getRosterIdOrPlaceholder(rosterOne);
  const rosterOneDefined = !isPlaceholderRoster(rosterOne);
  const rosterTwo = teams.rosters[1];
  const rosterTwoId = getRosterIdOrPlaceholder(rosterTwo);
  const rosterTwoDefined = !isPlaceholderRoster(rosterTwo);

  const rosterOneName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterOneId, tournamentId)
  );

  const rosterTwoName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterTwoId, tournamentId)
  );

  const trackName = useAppSelector((state) =>
    !!track.trackId
      ? selectTrackNameFromTournamentId(state, track.trackId, tournamentId)
      : undefined
  );

  const roundTimes = track.rounds.map((r) => r.times);
  return (
    <FlexRow>
      <SetMatchTrackName>
        Track {trackNum}
        <br />
        {trackName}
      </SetMatchTrackName>
      <SetMatchTrackTable>
        <thead>{getHeaderRow(track)}</thead>
        <tbody>
          <tr>
            <OrgNameCell>{rosterOneName}</OrgNameCell>
            <TrackTableCell>
              {rosterOneDefined ? track.scores[rosterOneId] ?? "-" : ""}
            </TrackTableCell>
            {track.rounds.map((round) => (
              <TrackTableCell colSpan={2}>
                {rosterOneDefined
                  ? round.results.find((r) => r.rosterId === rosterOneId)
                      ?.points ?? "-"
                  : ""}
              </TrackTableCell>
            ))}
          </tr>
          <tr>
            <OrgNameCell>{rosterTwoName}</OrgNameCell>
            <TrackTableCell>
              {rosterTwoDefined ? track.scores[rosterTwoId] ?? "-" : ""}
            </TrackTableCell>
            {track.rounds.map((round) => (
              <TrackTableCell colSpan={2}>
                {rosterTwoDefined
                  ? round.results.find((r) => r.rosterId === rosterTwoId)
                      ?.points ?? "-"
                  : ""}
              </TrackTableCell>
            ))}
          </tr>
          <RoundTimeRows
            roundTimes={roundTimes}
            tournamentId={tournamentId}
            showPosition={true}
            padding={1}
          />
        </tbody>
      </SetMatchTrackTable>
    </FlexRow>
  );
};

const getHeaderRow = (track: MatchTrack) => {
  const ths = [<th />, <th />];
  for (let i = 1; i <= track.rounds.length; i++) {
    ths.push(<TrackTableHeader colSpan={2}>Round {i}</TrackTableHeader>);
  }
  return <tr>{ths}</tr>;
};
